import { Reveal } from "@/components/site/Reveal";
import { Stethoscope, ShieldCheck, HeartHalf, Pulse, User, ClipboardText } from "@phosphor-icons/react";

const cards = [
  { icon: Stethoscope, title: "General Medical Consultation", desc: "Assessment and guidance for common adult health concerns." },
  { icon: ShieldCheck, title: "Preventive Health", desc: "Proactive guidance to help maintain long-term well-being." },
  { icon: ClipboardText, title: "Routine Health Assessment", desc: "Structured check-ins and general health reviews." },
  { icon: Pulse, title: "Chronic Condition Management", desc: "Ongoing support for the management of long-term conditions." },
  { icon: User, title: "Adult Healthcare", desc: "Focused, considered care for adult patients." },
  { icon: HeartHalf, title: "Health Guidance", desc: "Clear, informed explanations to support healthy choices." },
];

export function AreasOfCare() {
  return (
    <section id="expertise" className="py-24 md:py-32 bg-[#F4F7FA] scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <span className="label">Expertise</span>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight leading-tight mt-4 text-[#0A192F]">Areas of Care</h2>
          <p className="mt-5 text-lg text-[#475569] leading-relaxed">
            An overview of general areas relevant to the doctor's field.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="areas-of-care-grid">
          {cards.map((c, i) => (
            <Reveal key={c.title} delay={(i % 3) * 0.08}>
              <div className="group bg-white p-8 h-full rounded-2xl border border-[#E6EBF0] hover:border-[#0D9488] hover:shadow-[0_28px_56px_-28px_rgba(11,27,43,0.25)] hover:-translate-y-1 transition-[transform,border-color,box-shadow] duration-300">
                <div className="w-12 h-12 rounded-xl bg-[#F4F7FA] grid place-items-center group-hover:bg-[#0D9488] transition-colors duration-300">
                  <c.icon size={24} weight="bold" className="text-[#0D9488] group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="font-display text-xl mt-6 text-[#0B1B2B]">{c.title}</h3>
                <p className="mt-2 text-[#4A5A6A]">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-8 text-sm text-[#64748B] italic font-mono max-w-3xl">
            Note: The final list of services should be customised according to Dr. Sangeeta Roy's actual clinical practice. These are editable placeholders.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
